import GrayCard from "components/gray-card";
import Dropdown, { IDropItem } from "components/inputs/dropdown";
import TextInput from "components/inputs/text-input";
import Typography from "components/typography";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import { MusicGenres } from "constants/genres";
import { Languages } from "constants/languages";
import { IVideoData, VideoDataKeys } from "types/videoData";
import { GetUserArtists } from "services/user/getUser";

interface IProps {
  videoDetails: IVideoData;
  onChange: (key: VideoDataKeys, value: string) => void;
}
const StepOne = ({ videoDetails, onChange }: IProps) => {
  const Artists = () => {
    let temp = GetUserArtists();
    let data: (string | IDropItem)[] = ["None"];
    for (let i = 0; i < temp.length; i++) {
      data.push({
        label: temp[i].name,
        icon: (
          <ArtistIcon>
            <Typography size="s" color={Colors.white200}>
              {temp[i].name[0]}
            </Typography>
          </ArtistIcon>
        )
      });
    }
    return data;
  };
  return (
    <Container>
      <GrayCard title="Music Video Release Information">
        <TextInput
          label="Release Title"
          placeholder="Enter your Single, Album or EP name"
          value={videoDetails.releaseTitle}
          onChange={(e) => onChange("releaseTitle", e.target.value)}
        />
        <InputItem>
          <TextInput
            disabled
            lockIcon
            label="Record Label"
            placeholder="Rated Afrika"
            value={videoDetails.recordLabel}
            onChange={(e) => onChange("recordLabel", e.target.value)}
          />
        </InputItem>
        <InputItem>
          <Typography mb="0.4" weight="medium" color={Colors.grey400}>
            Primary Artist
          </Typography>
          <Dropdown
            items={Artists()}
            chosenItem={videoDetails.primaryArtist}
            selectItem={(value) => onChange("primaryArtist", value)}
          />
        </InputItem>
      </GrayCard>
      <GrayCard title="Release Genre">
        <Typography mb="0.4" weight="medium" color={Colors.grey400}>
          Release Language
        </Typography>
        <Dropdown
          items={Languages}
          chosenItem={videoDetails.releaseLanguage}
          selectItem={(value) => onChange("releaseLanguage", value)}
          placeholder="what language is your release title in?"
        />
        <InputItem>
          <Typography mb="0.4" weight="medium" color={Colors.grey400}>
            Primary Genre
          </Typography>
          <Dropdown
            items={MusicGenres}
            chosenItem={videoDetails.primaryGenre}
            selectItem={(value) => onChange("primaryGenre", value)}
            placeholder="Select a genre"
          />
        </InputItem>
        <InputItem>
          <Typography mb="0.4" weight="medium" color={Colors.grey400}>
            Secondary Genre
          </Typography>
          <Dropdown
            items={MusicGenres}
            chosenItem={videoDetails.secondaryGenre}
            selectItem={(value) => onChange("secondaryGenre", value)}
            placeholder="Select another genre"
          />
        </InputItem>
      </GrayCard>
    </Container>
  );
};

export default StepOne;

const Container = styled.div`
  width: 100%;
  position: relative;
`;

const InputItem = styled.div`
  width: 100%;
  margin-top: 2.4rem;
`;

const ArtistIcon = styled.div`
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${Colors.purple200};
`;
